import { render, staticRenderFns } from "./CreateWhatsAppMessageTemplate.vue?vue&type=template&id=441d57c1&"
import script from "./CreateWhatsAppMessageTemplate.vue?vue&type=script&lang=js&"
export * from "./CreateWhatsAppMessageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports